import React, { useContext } from "react";
import { AppContext } from "../../Context/AppContext";
import { createPaymentAccountLink } from "../../api/paymentAccount";

const CONNECT_ERROR_MESSAGES = {
  account_create_activation_required:
    "The French Florist main payment account is still activating. Try again later.",
};

// Wallet onboarding for the selected store. The store's Apple Pay / Google Pay
// switches stay off until the connected account is approved.
// account is undefined while the page loads it, null when the lookup failed.
const ConnectPayments = ({ storeId, account, canConnect }) => {
  const { showToastMessage, setIsLoading } = useContext(AppContext);
  const loading = account === undefined;

  const handleConnect = async () => {
    setIsLoading(true);
    const response = await createPaymentAccountLink(storeId);
    setIsLoading(false);

    const url = response?.data?.data?.url;
    if (!url) {
      const message =
        CONNECT_ERROR_MESSAGES[response?.data?.data?.code] ||
        response?.data?.message ||
        "Could not start the payment setup. Please try again.";
      showToastMessage(undefined, message, "error", false);
      return;
    }
    // Single use and short-lived, so it opens in the same tab and is never emailed.
    window.location.href = url;
  };

  const statusLabel = loading
    ? "Checking..."
    : account?.charges_enabled
      ? "Ready to accept payments"
      : account?.account_id
        ? "Setup not finished"
        : "Not connected";

  return (
    <div className="d-md-flex align-items-md-center mt-4 mb-1">
      <h3 className="bold">Connect payments</h3>
      <div className="row w-100">
        <div className="col-md-12">
          <p className="mb-2">{statusLabel}</p>
          {canConnect && (
            <button
              type="button"
              className="btn pink-btn"
              onClick={handleConnect}
              disabled={loading}
            >
              {account?.account_id ? "Continue setup" : "Connect payments"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectPayments;
